import Component from '../../js/_Component';
import kebabCase from "kebab-case";

const CNAME = 'c-base-form';

export default class BaseForm extends Component {
	private form: HTMLFormElement;

	private fields: (HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement)[];

	private successMessage: HTMLElement;

	private failureMessage: HTMLElement;

	private validationMessage: HTMLElement;

	constructor(element: HTMLElement) {
		super(element);

		this.form = element.querySelector(`.${CNAME}--form`);
		this.fields = Array.from(element.querySelectorAll('[name]'));
		this.successMessage = element.querySelector(`.${CNAME}--message.m-success`);
		this.failureMessage = element.querySelector(`.${CNAME}--message.m-failure`);
		this.validationMessage = element.querySelector(`.${CNAME}--message.m-validation`);

		const tellMeSelect = this.element.querySelector(`select[name="tell-me-more-about"]`) as HTMLSelectElement;

		this.appId = document.querySelector('body').dataset.appid ?? 'dev';

		// Watch tell me more for changes
		if(tellMeSelect){
			tellMeSelect.addEventListener('change', () => this.updateVisibleFields(tellMeSelect.value));
		}


		this.form.addEventListener('submit', (event) => {
			event.preventDefault();
			this.submit();
		});

		this.recaptchaAction = document.location.hostname.includes('dev') ? 'test' : `${this.appId}_formsubmit`;

		/* Want to mock some data? Sure you do.
			document.querySelector('input[name="first-name"]').value = "First";
			document.querySelector('input[name="last-name"]').value = "Last";
			document.querySelector('input[name="email"]').value = "email@email.email";
			document.querySelector('input[name="phone"]').value = "(111)-222-3333";
			document.querySelector('select[name="affiliation"] option[value="School"]').selected = true;
			document.querySelector('input[name="school-or-company-name"]').value = "School or Company";
			document.querySelector('textarea[name="question"]').value = "Question Goes here";
		 */

	}

	updateVisibleFields(selectValue: string) {

		let selectValueBase = kebabCase(selectValue).replace('-question','');

		// Hide all answer fields
		this.element.querySelectorAll('[class*="-answer"]').forEach(function(thisEl: HTMLElement){
			thisEl.classList.remove('active');
			let answerInput = thisEl.getElementsByTagName("input");
			let answerSelect = thisEl.getElementsByTagName("select");
			if(answerInput.length > 0){
				answerInput[0].removeAttribute('required');
			}
			if(answerSelect.length > 0){
				answerSelect[0].removeAttribute('required');
			}
		});

		// toggle applicable fields
		this.element.querySelectorAll( `.${CNAME}--${selectValueBase}-answer`).forEach(function(thisEl: HTMLElement){
			thisEl.classList.add('active');
			let answerInput = thisEl.getElementsByTagName("input");
			let answerSelect = thisEl.getElementsByTagName("select");
			if(answerInput.length > 0){
				answerInput[0].setAttribute('required','');
			}
			if(answerSelect.length > 0){
				answerSelect[0].setAttribute('required','');
			}
		});
	}

	collectData(){
		const data = {};
		const titleCase = str => str.toLowerCase().replace(/-/g,' ').replace(/\b\w/g,m1=>m1.toUpperCase());
		let isValid = true;
		let humanName;

		let inputs = this.fields.filter(field=>field.name.includes('answer')?false:true);
		//collect potential answer fields
		let answerInputs = this.fields.filter(field=>field.name.includes('answer')?true:false).reduce((result, answer) => {
  result[answer.name] = answer;
  return result;
}, {});

		inputs.forEach((field) => {

			// Get the root of this field
			let componentRoot = field.closest("."+field.classList[0].split("--")[0]);
			// Remove error class if it exists
			componentRoot.classList.remove('invalid');
			if(!field.validity.valid){
				componentRoot.classList.add('invalid');
				isValid = false;
				return;
			}

			if(field.type == "checkbox") {
				if (chechbox.checked) {
					data[titleCase(field.name)] = field.value;
				}
				return;
			}
			// Email handling
			// See https://developer.mozilla.org/en-US/docs/Learn/Forms/Form_validation
			// This is a very simplified version of what it could be
			if(field.type == "email"){
			//check that email again before sending
				let emailRegExp = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
				if(!emailRegExp.test(field.value)){
					componentRoot.classList.add('invalid');
					isValid = false;
					return;
				}
			}

			//check for question answer pair validity
			if(field.value.includes('-question')) {
				let answerField = answerInputs[field.value.replace('-question','-answer')];
				componentRoot = answerField.closest("."+answerField.classList[0].split("--")[0]);
				componentRoot.classList.remove('invalid');
				if(!answerField.validity.valid){
					componentRoot.classList.add('invalid');
					isValid = false;
					return;
				}
			}


			data[titleCase(field.name)] = field.value.includes('-question') ? answerInputs[field.value.replace('-question','-answer')].value: field.value;
		});

		if(isValid){
			// look for recaptchaV3 field on page
			let recaptchaField = document.getElementById("recaptcha-response");
			if(recaptchaField){
				data["Recaptcha Response"] = recaptchaField.value;
			}

			data["subject"] = this.form.dataset.subject ? this.form.dataset.subject : '';

			return data;
		}

		return false;

	}

	recaptchaV3(testFn){
		let _self = this;
		// get recaptcha token
		let recaptchaSiteEl = document.getElementById("recaptcha-response");
		if(recaptchaSiteEl){
			let recaptchaSiteKey = recaptchaSiteEl.dataset.parameter;
			grecaptcha.ready(function() { // Wait for the recaptcha to be ready
				grecaptcha
					.execute(recaptchaSiteKey, {
						action: _self.recaptchaAction
					}) // Execute the recaptcha
					.then(function(token){
						recaptchaSiteEl.value = token // Set the recaptcha response
					}).then(function(){
							_self.recaptchaCallBack();
					});
			});
		}else{
			_self.recaptchaCallBack();
		}
    };


	recaptchaCallBack() {
		const data = this.collectData();

		// Check to make sure we didn't get false.
		if(data == false){
			// Data failed
			this.validationMessageShow();
			return;
		} else {
			this.validationMessageHide();
		}

		const fetchOptions = {
			method: 'POST',
			headers: {'Content-Type': 'application/json'},
			body: JSON.stringify(data),
		};

		fetch(this.form.dataset.endpoint, fetchOptions)
			.then((response) => response.json())
			.then((response) => this.onSuccess(response))
			.catch(() => this.onFailure());
	}

	submit(){
		// set recaptcha token to submit to backend
		this.recaptchaV3();
	}

	onSuccess(response) {
		if (!response.success) {
			this.onFailure();
			return;
		}

		this.form.style.display = 'none';
		this.successMessage.style.display = 'block';
	}

	onFailure() {
		this.form.style.display = 'none';
		this.failureMessage.style.display = 'block';
	}

	validationMessageShow() {
		// Maybe we can attempt to make the message plural..
		let totalInvalid = this.element.querySelectorAll(`.${CNAME}--fields .invalid`) as NodeList;
		let pluralElement = this.element.querySelector(`.m-validation-plural`) as HTMLElement;

		if(totalInvalid.length > 1){
			pluralElement.classList.add('m-show');
		} else {
			pluralElement.classList.remove('m-show');
		}
		this.validationMessage.classList.add('m-show');
	}

	validationMessageHide() {
		this.validationMessage.classList.remove('m-show');
	}
}

Component.register(BaseForm, 'BaseForm');
